export const footerLinks = {
    'au-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://au.wingie.com/de/flug/nach-sydney/',
                    title: 'Sydney',
                },
                {
                    href: 'https://au.wingie.com/de/flug/nach-melbourne/',
                    title: 'Melbourne',
                },
                {
                    href: 'https://au.wingie.com/de/flug/nach-brisbane/',
                    title: 'Brisbane',
                },
                {
                    href: 'https://au.wingie.com/de/flug/nach-perth/',
                    title: 'Perth',
                },
                {
                    href: 'https://au.wingie.com/de/flug/nach-adelaide/',
                    title: 'Adelaide',
                },
                {
                    href: 'https://au.wingie.com/de/flug/nach-gold-coast/',
                    title: 'Gold Coast',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://au.wingie.com/de/flug/nz-neuseeland/',
                    title: 'Neuseeland',
                },
                {
                    href: 'https://au.wingie.com/de/flug/id-indonesien/',
                    title: 'Indonesien',
                },
                {
                    href: 'https://au.wingie.com/de/flug/th-thailand/',
                    title: 'Thailand',
                },
                {
                    href: 'https://au.wingie.com/de/flug/us-vereinigte-staaten-von-amerika/',
                    title: 'Vereinigte Staaten',
                },
                {
                    href: 'https://au.wingie.com/de/flug/gb-vereinigtes-konigreich/',
                    title: 'Großbritannien',
                },
                {
                    href: 'https://au.wingie.com/de/flug/jp-japan/',
                    title: 'Japan',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://au.wingie.com/de/flug/airlines/qantas/',
                    title: 'Qantas',
                },
                {
                    href: 'https://au.wingie.com/de/flug/airlines/virgin-australia/',
                    title: 'Virgin Australia',
                },
                {
                    href: 'https://au.wingie.com/de/flug/airlines/jetstar/',
                    title: 'Jetstar',
                },
                {
                    href: 'https://au.wingie.com/de/flug/airlines/regional-express/',
                    title: 'Regional Express',
                },
                {
                    href: 'https://au.wingie.com/de/flug/airlines/air-new-zealand/',
                    title: 'Air New Zealand',
                },
                {
                    href: 'https://au.wingie.com/de/flug/airlines/singapore-airlines/',
                    title: 'Singapore Airlines',
                },
            ],
        },
    ],
    'au-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    title: 'Sydney',
                    href: 'https://au.wingie.com/flights/to-sydney/',
                },
                {
                    title: 'Melbourne',
                    href: 'https://au.wingie.com/flights/to-melbourne/',
                },
                {
                    title: 'Brisbane',
                    href: 'https://au.wingie.com/flights/to-brisbane/',
                },
                {
                    title: 'Perth',
                    href: 'https://au.wingie.com/flights/to-perth/',
                },
                {
                    title: 'Adelaide',
                    href: 'https://au.wingie.com/flights/to-adelaide/',
                },
                {
                    title: 'Gold Coast',
                    href: 'https://au.wingie.com/flights/to-gold-coast/',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    title: 'New Zealand',
                    href: 'https://au.wingie.com/flights/nz-new-zealand/',
                },
                {
                    title: 'Indonesia',
                    href: 'https://au.wingie.com/flights/id-indonesia/',
                },
                {
                    title: 'United Kingdom',
                    href: 'https://au.wingie.com/flights/gb-united-kingdom/',
                },
                {
                    title: 'United States',
                    href: 'https://au.wingie.com/flights/us-united-states-of-america/',
                },
                {
                    title: 'Japan',
                    href: 'https://au.wingie.com/flights/jp-japan/',
                },
                {
                    title: 'Thailand',
                    href: 'https://au.wingie.com/flights/th-thailand/',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    title: 'Qantas',
                    href: 'https://au.wingie.com/flights/airlines/qantas/',
                },
                {
                    title: 'Virgin Australia',
                    href: 'https://au.wingie.com/flights/airlines/virgin-australia/',
                },
                {
                    title: 'Jetstar',
                    href: 'https://au.wingie.com/flights/airlines/jetstar/',
                },
                {
                    title: 'Regional Express',
                    href: 'https://au.wingie.com/flights/airlines/regional-express/',
                },
                {
                    title: 'Air New Zealand',
                    href: 'https://au.wingie.com/flights/airlines/air-new-zealand/',
                },
                {
                    title: 'Emirates',
                    href: 'https://au.wingie.com/flights/airlines/emirates/',
                },
            ],
        },
    ],
    'au-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    title: 'Sídney',
                    href: 'https://au.wingie.com/es/vuelos/a-sydney/',
                },
                {
                    title: 'Melbourne',
                    href: 'https://au.wingie.com/es/vuelos/a-melbourne/',
                },
                {
                    title: 'Brisbane',
                    href: 'https://au.wingie.com/es/vuelos/a-brisbane/',
                },
                {
                    title: 'Perth',
                    href: 'https://au.wingie.com/es/vuelos/a-perth/',
                },
                {
                    title: 'Adelaida',
                    href: 'https://au.wingie.com/es/vuelos/a-adelaide/',
                },
                {
                    title: 'Gold Coast',
                    href: 'https://au.wingie.com/es/vuelos/a-gold-coast/',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    title: 'Nueva Zelanda',
                    href: 'https://au.wingie.com/es/vuelos/nz-new-zealand/',
                },
                {
                    title: 'Indonesia',
                    href: 'https://au.wingie.com/es/vuelos/id-indonesia/',
                },
                {
                    title: 'Reino Unido',
                    href: 'https://au.wingie.com/es/vuelos/gb-reino-unido/',
                },
                {
                    title: 'Estados Unidos',
                    href: 'https://au.wingie.com/es/vuelos/us-united-states-of-america/',
                },
                {
                    title: 'Japón',
                    href: 'https://au.wingie.com/es/vuelos/jp-japan/',
                },
                {
                    title: 'Tailandia',
                    href: 'https://au.wingie.com/es/vuelos/th-thailand/',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    title: 'Qantas',
                    href: 'https://au.wingie.com/es/vuelos/companias-aereas/qantas/',
                },
                {
                    title: 'Virgin Australia',
                    href: 'https://au.wingie.com/es/vuelos/companias-aereas/virgin-australia/',
                },
                {
                    title: 'Jetstar',
                    href: 'https://au.wingie.com/es/vuelos/companias-aereas/jetstar/',
                },
                {
                    title: 'Regional Express',
                    href: 'https://au.wingie.com/es/vuelos/companias-aereas/regional-express/',
                },
                {
                    title: 'Air New Zealand',
                    href: 'https://au.wingie.com/es/vuelos/companias-aereas/air-new-zealand/',
                },
                {
                    title: 'Emirates',
                    href: 'https://au.wingie.com/es/vuelos/companias-aereas/emirates/',
                },
            ],
        },
    ],
    'au-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://au.wingie.com/ru/flights/to-sydney/',
                    title: 'Сидней',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/to-melbourne/',
                    title: 'Мельбурн',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/to-brisbane/',
                    title: 'Брисбен',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/to-perth/',
                    title: 'Перт',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/to-adelaide/',
                    title: 'Аделаида',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/to-gold-coast/',
                    title: 'Голд-Кост',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://au.wingie.com/ru/flights/nz-new-zealand/',
                    title: 'Новая Зеландия',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/id-indonesia/',
                    title: 'Индонезия',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/gb-united-kingdom/',
                    title: 'Великобритания',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/us-united-states-of-america/',
                    title: 'США',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/jp-japan/',
                    title: 'Япония',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/th-thailand/',
                    title: 'Таиланд',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://au.wingie.com/ru/flights/airlines/qantas/',
                    title: 'Qantas',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/airlines/virgin-australia/',
                    title: 'Virgin Australia',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/airlines/jetstar/',
                    title: 'Jetstar',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/airlines/regional-express/',
                    title: 'Regional Express',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/airlines/air-new-zealand/',
                    title: 'Air New Zealand',
                },
                {
                    href: 'https://au.wingie.com/ru/flights/airlines/emirates/',
                    title: 'Emirates',
                },
            ],
        },
    ],
    'au-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://au.wingie.com/ar/flights/to-sydney/',
                    title: 'سيدني',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/to-melbourne/',
                    title: 'ملبورن',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/to-brisbane/',
                    title: 'بريزبن',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/to-perth/',
                    title: 'بيرث',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/to-adelaide/',
                    title: 'أديليد',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/to-gold-coast/',
                    title: 'جولد كوست',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://au.wingie.com/ar/flights/nz-new-zealand/',
                    title: 'نيوزيلندا',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/id-indonesia/',
                    title: 'إندونيسيا',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/gb-united-kingdom/',
                    title: 'المملكة المتحدة',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/us-united-states-of-america/',
                    title: 'الولايات المتحدة',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/jp-japan/',
                    title: 'اليابان',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/th-thailand/',
                    title: 'تايلاند',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://au.wingie.com/ar/flights/airlines/qantas/',
                    title: 'كانتاس',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/airlines/virgin-australia/',
                    title: 'فيرجن أستراليا',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/airlines/jetstar/',
                    title: 'جيتستار',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/airlines/regional-express/',
                    title: 'ريكس ايرلاينز',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/airlines/air-new-zealand/',
                    title: 'طيران نيوزيلندا',
                },
                {
                    href: 'https://au.wingie.com/ar/flights/airlines/emirates/',
                    title: 'طيران الإمارات',
                },
            ],
        },
    ],
    'au-it': [
        {
            title: 'Destinazioni Top',
            items: [
                { title: 'Sydney', href: 'https://au.wingie.com/it/flights/to-sydney/' },
                { title: 'Melbourne', href: 'https://au.wingie.com/it/flights/to-melbourne/' },
                { title: 'Brisbane', href: 'https://au.wingie.com/it/flights/to-brisbane/' },
                { title: 'Perth', href: 'https://au.wingie.com/it/flights/to-perth/' },
                { title: 'Adelaide', href: 'https://au.wingie.com/it/flights/to-adelaide/' },
                { title: 'Gold Coast', href: 'https://au.wingie.com/it/flights/to-gold-coast/' },
            ],
        },
        {
            title: 'Paesi Popolari',
            items: [
                { title: 'Nuova Zelanda', href: 'https://au.wingie.com/it/flights/nz-nuova-zelanda/' },
                { title: 'Indonesia', href: 'https://au.wingie.com/it/flights/id-indonesia/' },
                { title: 'Regno Unito', href: 'https://au.wingie.com/it/flights/gb-regno-unito/' },
                { title: 'Stati Uniti', href: 'https://au.wingie.com/it/flights/us-stati-uniti/' },
                { title: 'Giappone', href: 'https://au.wingie.com/it/flights/jp-giappone/' },
                { title: 'Tailandia', href: 'https://au.wingie.com/it/flights/th-tailandia/' },
            ],
        },
        {
            title: 'Compagnie Aeree Popolari',
            items: [
                { title: 'Qantas', href: 'https://au.wingie.com/it/flights/airlines/qantas/' },
                { title: 'Virgin Australia', href: 'https://au.wingie.com/it/flights/airlines/virgin-australia/' },
                { title: 'Jetstar', href: 'https://au.wingie.com/it/flights/airlines/jetstar/' },
                { title: 'Regional Express', href: 'https://au.wingie.com/it/flights/airlines/regional-express/' },
                { title: 'Air New Zealand', href: 'https://au.wingie.com/it/flights/airlines/air-new-zealand/' },
                { title: 'Emirates', href: 'https://au.wingie.com/it/flights/airlines/emirates/' },
            ],
        },
    ],
    'au-fr': [
        {
            title: 'Destinations Populaires',
            items: [
                { title: 'Sydney', href: 'https://au.wingie.com/fr/flights/to-sydney/' },
                { title: 'Melbourne', href: 'https://au.wingie.com/fr/flights/to-melbourne/' },
                { title: 'Brisbane', href: 'https://au.wingie.com/fr/flights/to-brisbane/' },
                { title: 'Perth', href: 'https://au.wingie.com/fr/flights/to-perth/' },
                { title: 'Adélaïde', href: 'https://au.wingie.com/fr/flights/to-adelaide/' },
                { title: 'Gold Coast', href: 'https://au.wingie.com/fr/flights/to-gold-coast/' },
            ],
        },
        {
            title: 'Pays Populaires',
            items: [
                { title: 'Nouvelle-Zélande', href: 'https://au.wingie.com/fr/flights/nz-nouvelle-zelande/' },
                { title: 'Indonésie', href: 'https://au.wingie.com/fr/flights/id-indonesie/' },
                { title: 'Royaume-Uni', href: 'https://au.wingie.com/fr/flights/gb-royaume-uni/' },
                { title: 'États-Unis', href: 'https://au.wingie.com/fr/flights/us-etats-unis/' },
                { title: 'Japon', href: 'https://au.wingie.com/fr/flights/jp-japon/' },
                { title: 'Tailandia', href: 'https://au.wingie.com/fr/flights/th-tailandia/' },
            ],
        },
        {
            title: 'Compagnies Aériennes Populaires',
            items: [
                { title: 'Qantas', href: 'https://au.wingie.com/fr/flights/airlines/qantas/' },
                { title: 'Virgin Australia', href: 'https://au.wingie.com/fr/flights/airlines/virgin-australia/' },
                { title: 'Jetstar', href: 'https://au.wingie.com/fr/flights/airlines/jetstar/' },
                { title: 'Regional Express', href: 'https://au.wingie.com/fr/flights/airlines/regional-express/' },
                { title: 'Air New Zealand', href: 'https://au.wingie.com/fr/flights/airlines/air-new-zealand/' },
                { title: 'Emirates', href: 'https://au.wingie.com/fr/flights/airlines/emirates/' },
            ],
        },
    ],
    'au-pt': [
        {
            title: 'Destinos Populares',
            items: [
                { title: 'Sydney', href: 'https://au.wingie.com/pt/flights/to-sydney/' },
                { title: 'Melbourne', href: 'https://au.wingie.com/pt/flights/to-melbourne/' },
                { title: 'Brisbane', href: 'https://au.wingie.com/pt/flights/to-brisbane/' },
                { title: 'Perth', href: 'https://au.wingie.com/pt/flights/to-perth/' },
                { title: 'Adelaide', href: 'https://au.wingie.com/pt/flights/to-adelaide/' },
                { title: 'Gold Coast', href: 'https://au.wingie.com/pt/flights/to-gold-coast/' },
            ],
        },
        {
            title: 'Países Populares',
            items: [
                { title: 'Nova Zelândia', href: 'https://au.wingie.com/pt/flights/nz-nova-zelandia/' },
                { title: 'Indonésia', href: 'https://au.wingie.com/pt/flights/id-indonesia/' },
                { title: 'Reino Unido', href: 'https://au.wingie.com/pt/flights/gb-reino-unido/' },
                { title: 'Estados Unidos', href: 'https://au.wingie.com/pt/flights/us-estados-unidos/' },
                { title: 'Japão', href: 'https://au.wingie.com/pt/flights/jp-japao/' },
                { title: 'Tailândia', href: 'https://au.wingie.com/pt/flights/th-tailandia/' },
            ],
        },
        {
            title: 'Companhias Aéreas Populares',
            items: [
                { title: 'Qantas', href: 'https://au.wingie.com/pt/flights/airlines/qantas/' },
                { title: 'Virgin Australia', href: 'https://au.wingie.com/pt/flights/airlines/virgin-australia/' },
                { title: 'Jetstar', href: 'https://au.wingie.com/pt/flights/airlines/jetstar/' },
                { title: 'Regional Express', href: 'https://au.wingie.com/pt/flights/airlines/regional-express/' },
                { title: 'Air New Zealand', href: 'https://au.wingie.com/pt/flights/airlines/air-new-zealand/' },
                { title: 'Emirates', href: 'https://au.wingie.com/pt/flights/airlines/emirates/' },
            ],
        },
    ],
    'au-ro': [
        {
            title: 'Destinații Populare',
            items: [
                { title: 'Sydney', href: 'https://au.wingie.com/ro/flights/to-sydney/' },
                { title: 'Melbourne', href: 'https://au.wingie.com/ro/flights/to-melbourne/' },
                { title: 'Brisbane', href: 'https://au.wingie.com/ro/flights/to-brisbane/' },
                { title: 'Perth', href: 'https://au.wingie.com/ro/flights/to-perth/' },
                { title: 'Adelaide', href: 'https://au.wingie.com/ro/flights/to-adelaide/' },
                { title: 'Gold Coast', href: 'https://au.wingie.com/ro/flights/to-gold-coast/' },
            ],
        },
        {
            title: 'Țări Populare',
            items: [
                { title: 'Noua Zeelandă', href: 'https://au.wingie.com/ro/flights/nz-nieuw-zeeland/' },
                { title: 'Indonezia', href: 'https://au.wingie.com/ro/flights/id-indonezia/' },
                { title: 'Regatul Unit', href: 'https://au.wingie.com/ro/flights/gb-regatul-unit/' },
                { title: 'Statele Unite', href: 'https://au.wingie.com/ro/flights/us-statele-unite-ale-americii/' },
                { title: 'Japonia', href: 'https://au.wingie.com/ro/flights/jp-japonia/' },
                { title: 'Tailandă', href: 'https://au.wingie.com/ro/flights/th-tailanda/' },
            ],
        },
        {
            title: 'Companii Aeriene Populare',
            items: [
                { title: 'Qantas', href: 'https://au.wingie.com/ro/flights/airlines/qantas/' },
                { title: 'Virgin Australia', href: 'https://au.wingie.com/ro/flights/airlines/virgin-australia/' },
                { title: 'Jetstar', href: 'https://au.wingie.com/ro/flights/airlines/jetstar/' },
                { title: 'Regional Express', href: 'https://au.wingie.com/ro/flights/airlines/regional-express/' },
                { title: 'Air New Zealand', href: 'https://au.wingie.com/ro/flights/airlines/air-new-zealand/' },
                { title: 'Emirates', href: 'https://au.wingie.com/ro/flights/airlines/emirates/' },
            ],
        },
    ],
    'au-pl': [
        {
            title: 'Popularne Destynacje',
            items: [
                { title: 'Sydney', href: 'https://au.wingie.com/pl/flights/to-sydney/' },
                { title: 'Melbourne', href: 'https://au.wingie.com/pl/flights/to-melbourne/' },
                { title: 'Brisbane', href: 'https://au.wingie.com/pl/flights/to-brisbane/' },
                { title: 'Perth', href: 'https://au.wingie.com/pl/flights/to-perth/' },
                { title: 'Adelaide', href: 'https://au.wingie.com/pl/flights/to-adelaide/' },
                { title: 'Gold Coast', href: 'https://au.wingie.com/pl/flights/to-gold-coast/' },
            ],
        },
        {
            title: 'Popularne Kraje',
            items: [
                { title: 'Nowa Zelandia', href: 'https://au.wingie.com/pl/flights/nz-nowa-zelandia/' },
                { title: 'Indonezja', href: 'https://au.wingie.com/pl/flights/id-indonezja/' },
                { title: 'Wielka Brytania', href: 'https://au.wingie.com/pl/flights/gb-wielka-brytania/' },
                { title: 'Stany Zjednoczone', href: 'https://au.wingie.com/pl/flights/us-stany-zjednoczone/' },
                { title: 'Japonia', href: 'https://au.wingie.com/pl/flights/jp-japonia/' },
                { title: 'Tajlandia', href: 'https://au.wingie.com/pl/flights/th-tajlandia/' },
            ],
        },
        {
            title: 'Popularne Linie Lotnicze',
            items: [
                { title: 'Qantas', href: 'https://au.wingie.com/pl/flights/airlines/qantas/' },
                { title: 'Virgin Australia', href: 'https://au.wingie.com/pl/flights/airlines/virgin-australia/' },
                { title: 'Jetstar', href: 'https://au.wingie.com/pl/flights/airlines/jetstar/' },
                { title: 'Regional Express', href: 'https://au.wingie.com/pl/flights/airlines/regional-express/' },
                { title: 'Air New Zealand', href: 'https://au.wingie.com/pl/flights/airlines/air-new-zealand/' },
                { title: 'Emirates', href: 'https://au.wingie.com/pl/flights/airlines/emirates/' },
            ],
        },
    ],
    'au-lt': [
        {
            title: 'Populiarūs Kryptys',
            items: [
                { title: 'Sidnėjus', href: 'https://au.wingie.com/lt/flights/to-sydney/' },
                { title: 'Melburnas', href: 'https://au.wingie.com/lt/flights/to-melbourne/' },
                { title: 'Brisbenas', href: 'https://au.wingie.com/lt/flights/to-brisbane/' },
                { title: 'Pertas', href: 'https://au.wingie.com/lt/flights/to-perth/' },
                { title: 'Adelaidė', href: 'https://au.wingie.com/lt/flights/to-adelaide/' },
                { title: 'Aukso Krantas', href: 'https://au.wingie.com/lt/flights/to-gold-coast/' },
            ],
        },
        {
            title: 'Populiarios Šalys',
            items: [
                { title: 'Naujoji Zelandija', href: 'https://au.wingie.com/lt/flights/nz-naujoji-zelandija/' },
                { title: 'Indonezija', href: 'https://au.wingie.com/lt/flights/id-indonezija/' },
                { title: 'Jungtinė Karalystė', href: 'https://au.wingie.com/lt/flights/gb-jungtine-karalyste/' },
                { title: 'Jungtinės Valstijos', href: 'https://au.wingie.com/lt/flights/us-jungtines-amerikos-valstijos/' },
                { title: 'Japonija', href: 'https://au.wingie.com/lt/flights/jp-japonija/' },
                { title: 'Tailandas', href: 'https://au.wingie.com/lt/flights/th-tailandas/' },
            ],
        },
        {
            title: 'Populiarios Oro Linijos',
            items: [
                { title: 'Qantas', href: 'https://au.wingie.com/lt/flights/airlines/qantas/' },
                { title: 'Virgin Australia', href: 'https://au.wingie.com/lt/flights/airlines/virgin-australia/' },
                { title: 'Jetstar', href: 'https://au.wingie.com/lt/flights/airlines/jetstar/' },
                { title: 'Regional Express', href: 'https://au.wingie.com/lt/flights/airlines/regional-express/' },
                { title: 'Air New Zealand', href: 'https://au.wingie.com/lt/flights/airlines/air-new-zealand/' },
                { title: 'Emirates', href: 'https://au.wingie.com/lt/flights/airlines/emirates/' },
            ],
        },
    ],
    'au-uz': [
        {
            title: "Mashhur Yo'nalishlar",
            items: [
                { title: 'Sidney', href: 'https://au.wingie.com/uz/flights/to-sydney/' },
                { title: 'Melburn', href: 'https://au.wingie.com/uz/flights/to-melbourne/' },
                { title: 'Brisben', href: 'https://au.wingie.com/uz/flights/to-brisbane/' },
                { title: 'Pert', href: 'https://au.wingie.com/uz/flights/to-perth/' },
                { title: 'Adelaida', href: 'https://au.wingie.com/uz/flights/to-adelaide/' },
                { title: 'Gold Coast', href: 'https://au.wingie.com/uz/flights/to-gold-coast/' },
            ],
        },
        {
            title: 'Mashhur Davlatlar',
            items: [
                { title: 'Yangi Zelandiya', href: 'https://au.wingie.com/uz/flights/nz-yangi-zelandiya/' },
                { title: 'Indoneziya', href: 'https://au.wingie.com/uz/flights/id-indoneziya/' },
                { title: 'Buyuk Britaniya', href: 'https://au.wingie.com/uz/flights/gb-buyuk-britaniya/' },
                { title: "Amerika Qo'shma Shtatlari", href: 'https://au.wingie.com/uz/flights/us-united-states-of-america/' },
                { title: 'Yaponiya', href: 'https://au.wingie.com/uz/flights/jp-yaponiya/' },
                { title: 'Tailand', href: 'https://au.wingie.com/uz/flights/th-tailand/' },
            ],
        },
        {
            title: 'Mashhur Aviakompaniyalar',
            items: [
                { title: 'Qantas', href: 'https://au.wingie.com/uz/flights/airlines/qantas/' },
                { title: 'Virgin Australia', href: 'https://au.wingie.com/uz/flights/airlines/virgin-australia/' },
                { title: 'Jetstar', href: 'https://au.wingie.com/uz/flights/airlines/jetstar/' },
                { title: 'Regional Express', href: 'https://au.wingie.com/uz/flights/airlines/regional-express/' },
                { title: 'Air New Zealand', href: 'https://au.wingie.com/uz/flights/airlines/air-new-zealand/' },
                { title: 'Emirates', href: 'https://au.wingie.com/uz/flights/airlines/emirates/' },
            ],
        },
    ],
    'au-sr': [
        {
            title: 'Popularne Destinacije',
            items: [
                { title: 'Sidnej', href: 'https://au.wingie.com/sr/flights/to-sydney/' },
                { title: 'Melburn', href: 'https://au.wingie.com/sr/flights/to-melbourne/' },
                { title: 'Brizben', href: 'https://au.wingie.com/sr/flights/to-brisbane/' },
                { title: 'Pert', href: 'https://au.wingie.com/sr/flights/to-perth/' },
                { title: 'Adelejd', href: 'https://au.wingie.com/sr/flights/to-adelaide/' },
                { title: 'Gold Coast', href: 'https://au.wingie.com/sr/flights/to-gold-coast/' },
            ],
        },
        {
            title: 'Popularne Zemlje',
            items: [
                { title: 'Novi Zeland', href: 'https://au.wingie.com/sr/flights/nz-novi-zeland/' },
                { title: 'Indonezija', href: 'https://au.wingie.com/sr/flights/id-indonezija/' },
                { title: 'Velika Britanija', href: 'https://au.wingie.com/sr/flights/gb-ujedinjeno-kraljevstvo/' },
                { title: 'Sjedinjene Američke Države', href: 'https://au.wingie.com/sr/flights/us-etats-unis/' },
                { title: 'Japan', href: 'https://au.wingie.com/sr/flights/jp-japan/' },
                { title: 'Tajland', href: 'https://au.wingie.com/sr/flights/th-tajland/' },
            ],
        },
        {
            title: 'Popularne Avio-kompanije',
            items: [
                { title: 'Qantas', href: 'https://au.wingie.com/sr/flights/airlines/qantas/' },
                { title: 'Virgin Australia', href: 'https://au.wingie.com/sr/flights/airlines/virgin-australia/' },
                { title: 'Jetstar', href: 'https://au.wingie.com/sr/flights/airlines/jetstar/' },
                { title: 'Regional Express', href: 'https://au.wingie.com/sr/flights/airlines/regional-express/' },
                { title: 'Air New Zealand', href: 'https://au.wingie.com/sr/flights/airlines/air-new-zealand/' },
                { title: 'Emirates', href: 'https://au.wingie.com/sr/flights/airlines/emirates/' },
            ],
        },
    ],
    'au-ky': [
        {
            title: 'Популярдуу Багыттар',
            items: [
                { title: 'Сидней', href: 'https://au.wingie.com/ky/flights/to-sydney/' },
                { title: 'Мельбурн', href: 'https://au.wingie.com/ky/flights/to-melbourne/' },
                { title: 'Брисбен', href: 'https://au.wingie.com/ky/flights/to-brisbane/' },
                { title: 'Перт', href: 'https://au.wingie.com/ky/flights/to-perth/' },
                { title: 'Аделаида', href: 'https://au.wingie.com/ky/flights/to-adelaide/' },
                { title: 'Gold Coast', href: 'https://au.wingie.com/ky/flights/to-gold-coast/' },
            ],
        },
        {
            title: 'Популярдуу Өлкөлөр',
            items: [
                { title: 'Жаңы Зеландия', href: 'https://au.wingie.com/ky/flights/nz-new-zealand/' },
                { title: 'Индонезия', href: 'https://au.wingie.com/ky/flights/id-indonesia/' },
                { title: 'Улуу Британия', href: 'https://au.wingie.com/ky/flights/gb-united-kingdom/' },
                { title: 'АКШ', href: 'https://au.wingie.com/ky/flights/us-amerika-koshmo-shtattary/' },
                { title: 'Япония', href: 'https://au.wingie.com/ky/flights/jp-japan/' },
                { title: 'Тайланд', href: 'https://au.wingie.com/ky/flights/th-thailand/' },
            ],
        },
        {
            title: 'Популярдуу Авиакомпаниялар',
            items: [
                { title: 'Qantas', href: 'https://au.wingie.com/ky/flights/airlines/qantas/' },
                { title: 'Virgin Australia', href: 'https://au.wingie.com/ky/flights/airlines/virgin-australia/' },
                { title: 'Jetstar', href: 'https://au.wingie.com/ky/flights/airlines/jetstar/' },
                { title: 'Regional Express', href: 'https://au.wingie.com/ky/flights/airlines/regional-express/' },
                { title: 'Air New Zealand', href: 'https://au.wingie.com/ky/flights/airlines/air-new-zealand/' },
                { title: 'Emirates', href: 'https://au.wingie.com/ky/flights/airlines/emirates/' },
            ],
        },
    ],
    'au-tg': [
        {
            title: 'Масҳуртарин Самтҳо',
            items: [
                { title: 'Сидней', href: 'https://au.wingie.com/tg/flights/to-sydney/' },
                { title: 'Мелбурн', href: 'https://au.wingie.com/tg/flights/to-melbourne/' },
                { title: 'Брисбан', href: 'https://au.wingie.com/tg/flights/to-brisbane/' },
                { title: 'Перт', href: 'https://au.wingie.com/tg/flights/to-perth/' },
                { title: 'Аделаида', href: 'https://au.wingie.com/tg/flights/to-adelaide/' },
                { title: 'Gold Coast', href: 'https://au.wingie.com/tg/flights/to-gold-coast/' },
            ],
        },
        {
            title: 'Масҳуртарин Кишварҳо',
            items: [
                { title: 'Зеландияи Нав', href: 'https://au.wingie.com/tg/flights/nz-new-zealand/' },
                { title: 'Индонезия', href: 'https://au.wingie.com/tg/flights/id-indonesia/' },
                { title: 'Британияи Кабир', href: 'https://au.wingie.com/tg/flights/gb-united-kingdom/' },
                { title: 'ИМА', href: 'https://au.wingie.com/tg/flights/us-iyoloti-muttahidai-amriko/' },
                { title: 'Ҷопон', href: 'https://au.wingie.com/tg/flights/jp-japan/' },
                { title: 'Тайланд', href: 'https://au.wingie.com/tg/flights/th-thailand/' },
            ],
        },
        {
            title: 'Масҳуртарин Авиакомпанияҳо',
            items: [
                { title: 'Qantas', href: 'https://au.wingie.com/tg/flights/airlines/qantas/' },
                { title: 'Virgin Australia', href: 'https://au.wingie.com/tg/flights/airlines/virgin-australia/' },
                { title: 'Jetstar', href: 'https://au.wingie.com/tg/flights/airlines/jetstar/' },
                { title: 'Regional Express', href: 'https://au.wingie.com/tg/flights/airlines/regional-express/' },
                { title: 'Air New Zealand', href: 'https://au.wingie.com/tg/flights/airlines/air-new-zealand/' },
                { title: 'Emirates', href: 'https://au.wingie.com/tg/flights/airlines/emirates/' },
            ],
        },
    ],
    'au-kk': [
        {
            title: 'Танымал Бағыттар',
            items: [
                { title: 'Сидней', href: 'https://au.wingie.com/kk/flights/to-sydney/' },
                { title: 'Мельбурн', href: 'https://au.wingie.com/kk/flights/to-melbourne/' },
                { title: 'Брисбен', href: 'https://au.wingie.com/kk/flights/to-brisbane/' },
                { title: 'Перт', href: 'https://au.wingie.com/kk/flights/to-perth/' },
                { title: 'Аделаида', href: 'https://au.wingie.com/kk/flights/to-adelaide/' },
                { title: 'Gold Coast', href: 'https://au.wingie.com/kk/flights/to-gold-coast/' },
            ],
        },
        {
            title: 'Танымал Елдер',
            items: [
                { title: 'Жаңа Зеландия', href: 'https://au.wingie.com/kk/flights/nz-new-zealand/' },
                { title: 'Индонезия', href: 'https://au.wingie.com/kk/flights/id-indonesia/' },
                { title: 'Ұлыбритания', href: 'https://au.wingie.com/kk/flights/gb-united-kingdom/' },
                { title: 'АҚШ', href: 'https://au.wingie.com/kk/flights/us-amerika-qosalgan-shtattary/' },
                { title: 'Жапония', href: 'https://au.wingie.com/kk/flights/jp-japan/' },
                { title: 'Тайланд', href: 'https://au.wingie.com/kk/flights/th-thailand/' },
            ],
        },
        {
            title: 'Танымал Авиакомпаниялар',
            items: [
                { title: 'Qantas', href: 'https://au.wingie.com/kk/flights/airlines/qantas/' },
                { title: 'Virgin Australia', href: 'https://au.wingie.com/kk/flights/airlines/virgin-australia/' },
                { title: 'Jetstar', href: 'https://au.wingie.com/kk/flights/airlines/jetstar/' },
                { title: 'Regional Express', href: 'https://au.wingie.com/kk/flights/airlines/regional-express/' },
                { title: 'Air New Zealand', href: 'https://au.wingie.com/kk/flights/airlines/air-new-zealand/' },
                { title: 'Emirates', href: 'https://au.wingie.com/kk/flights/airlines/emirates/' },
            ],
        },
    ],
    'au-nl': [
        {
            title: 'Populaire Bestemmingen',
            items: [
                { title: 'Sydney', href: 'https://au.wingie.com/nl/flights/to-sydney/' },
                { title: 'Melbourne', href: 'https://au.wingie.com/nl/flights/to-melbourne/' },
                { title: 'Brisbane', href: 'https://au.wingie.com/nl/flights/to-brisbane/' },
                { title: 'Perth', href: 'https://au.wingie.com/nl/flights/to-perth/' },
                { title: 'Adelaide', href: 'https://au.wingie.com/nl/flights/to-adelaide/' },
                { title: 'Gold Coast', href: 'https://au.wingie.com/nl/flights/to-gold-coast/' },
            ],
        },
        {
            title: 'Populaire Landen',
            items: [
                { title: 'Nieuw-Zeeland', href: 'https://au.wingie.com/nl/flights/nz-nieuw-zeeland/' },
                { title: 'Indonesië', href: 'https://au.wingie.com/nl/flights/id-indonesie/' },
                { title: 'Verenigd Koninkrijk', href: 'https://au.wingie.com/nl/flights/gb-verenigd-koninkrijk/' },
                { title: 'Verenigde Staten', href: 'https://au.wingie.com/nl/flights/us-verenigde-staten/' },
                { title: 'Japan', href: 'https://au.wingie.com/nl/flights/jp-japan/' },
                { title: 'Thailand', href: 'https://au.wingie.com/nl/flights/th-thailand/' },
            ],
        },
        {
            title: 'Populaire Luchtvaartmaatschappijen',
            items: [
                { title: 'Qantas', href: 'https://au.wingie.com/nl/flights/airlines/qantas/' },
                { title: 'Virgin Australia', href: 'https://au.wingie.com/nl/flights/airlines/virgin-australia/' },
                { title: 'Jetstar', href: 'https://au.wingie.com/nl/flights/airlines/jetstar/' },
                { title: 'Regional Express', href: 'https://au.wingie.com/nl/flights/airlines/regional-express/' },
                { title: 'Air New Zealand', href: 'https://au.wingie.com/nl/flights/airlines/air-new-zealand/' },
                { title: 'Emirates', href: 'https://au.wingie.com/nl/flights/airlines/emirates/' },
            ],
        },
    ],
    'au-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://au.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://au.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://au.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://au.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://au.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://au.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://au.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://au.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://au.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://au.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://au.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://au.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://au.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://au.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://au.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://au.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://au.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://au.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'au-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://au.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://au.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://au.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://au.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://au.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://au.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://au.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://au.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://au.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://au.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://au.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://au.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://au.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://au.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://au.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://au.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://au.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://au.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'au-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://au.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://au.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://au.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://au.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://au.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://au.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://au.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://au.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://au.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://au.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://au.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://au.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://au.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://au.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://au.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://au.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://au.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://au.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'au-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://au.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://au.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://au.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://au.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://au.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://au.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://au.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://au.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://au.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://au.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://au.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://au.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://au.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://au.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://au.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://au.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://au.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://au.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'au-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://au.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://au.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://au.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://au.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://au.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://au.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://au.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://au.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://au.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://au.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://au.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://au.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://au.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://au.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://au.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://au.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://au.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://au.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'au-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://au.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://au.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://au.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://au.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://au.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://au.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://au.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://au.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://au.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://au.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://au.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://au.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://au.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://au.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://au.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://au.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://au.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://au.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'au-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://au.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://au.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://au.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://au.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://au.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://au.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://au.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://au.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://au.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://au.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://au.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://au.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://au.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://au.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://au.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://au.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://au.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://au.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'au-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://au.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://au.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://au.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://au.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://au.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://au.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://au.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://au.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://au.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://au.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://au.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://au.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://au.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://au.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://au.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://au.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://au.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://au.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}